import * as ko from "knockout";
import {hubSpotSupport} from "../../../tracking/HubSpotSupport";
import {storeObservable} from "../../../util/sessionstore";
import hubspot_chatHtml from './hubspot-chat.html?raw';

export const template = hubspot_chatHtml;

export class viewModel {

    readonly isLoading = ko.observable(true);

    constructor() {
        if (!hubSpotSupport.isChatAvailable()) {
            storeObservable('layout.right.toggle')(false);
            this.isLoading(false);
            return;
        }
        hubSpotSupport.loadInlineChat({
            onLoaded: () => this.isLoading(false),
        });
    }

    dispose(): void {
        hubSpotSupport.unloadInlineChat();
    }

}
